import { AreaChartOutlined, BarChartOutlined, LineChartOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { hasPermission } from '@lima/seraphim-react';
import { Popover, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { SYSTEMPermission } from "../../../permissions/system";
import { axios_ } from "../../../tools/axios_";
import { isMechant, numFormat2Thousand, Utils } from "../../../tools/utils";
import { jumpToLaunch } from '../../activity/component/jumpActivityLaunch';
import { LmCarousel } from '../../activity/component/lmCarousel';
import DataCount from "./DataCount";
import KeyProducts from "./KeyProducts";
import './index.less';

const { TabPane } = Tabs;

// 组件：轮播图
export const CarouselCustom = props => {
  const [list, setList] = useState([]);
  // 是否展示banner，只有商户展示（有几家特殊商户不展示南航保险经纪有限公司、小帮规划、慧凡教育等），机构不展示
  const isShow = (item) => {
    const { companyLevelId, companyId } = Utils.getUserData();
    return companyLevelId === '10005' && (item.ids || []).filter(id => id === companyId).length <= 0;
  };
  // 本地json中有两个banner图，根据ids数据来判断使用哪个
  const getLocalList = (list = []) => {
    return list.filter(item => {
      return isShow(item)
    })
  };
  useEffect(_ => {
    requestLocalJson();
  }, []);

  // 请求本地json
  const requestLocalJson = () => {
    //   const url = `${window.location.origin}${window.location.pathname}${window.location.href.includes('grainbuds') ? '/' : ''}home_banner_list.json?timestamp=${new Date().getTime()}`
    // axios_({
    //   url,
    //   method:'get',
    // }).then(res => {
    //   if (res.status === 200) {
    //     const list = res.data || [];
    getCarouselList([]);
    //   }
    // })
    return [];
  }
  // 获取轮播图列表
  const getCarouselList = (localList = []) => {
    axios_({
      url: '/api/commission/activityRule/getPcBannerList',
      method: 'get',
      headers: { 'Authorization': props.token }
    }).then(res => {
      if (res.data.status === 200) {
        setList([
          ...getLocalList(localList),
          ...res.data.data,
        ]);
      }
    }).catch(() => { });
  };
  return (
    list && list.length > 0 &&
    <div className="homepage_carousel_div">
      <LmCarousel
        list={list}
        {...props}
        onClick={index => {
          const _list = list.filter((item, pos) => pos === index);
          const item = _list.length > 0 ? _list[0] : {};
          Utils.customTrack('MerchantHomeClick', {
            element_content: '活动banner'
          });
          jumpToLaunch(item, props)
        }}
      />
    </div>
  )
};

// 组件：统计规则-弹窗
const RegularPop = () => {
  const getContent = () => {
    return (
      isMechant() ?
        <div className="activity_yesterday_question_tips">
          <p className="title">统计规则:</p>
          <p className="desc">承保时间在活动时间内，包含当前账户及所有下级机构团队，仅统计进行中的活动</p>

          <p className="title marTop10">进行中活动:</p>
          <p className="desc">当前时间正在进行中的活动数量</p>

          <p className="title marTop10">业务员获得奖励:</p>
          <p className="desc">下级所有业务员的活动奖励之和</p>

          <p className="title marTop10">机构获得奖励:</p>
          <p className="desc">当前机构获得的活动奖励</p>
        </div>
        :
        <div className="activity_yesterday_question_tips">
          <p className="title">统计规则:</p>
          <p className="desc">承保时间在活动时间内，包含当前账户及所有下级机构团队，仅统计进行中的活动</p>

          <p className="title marTop10">进行中活动:</p>
          <p className="desc">当前时间正在进行中的活动数量</p>

          <p className="title marTop10">业务员获得奖励:</p>
          <p className="desc">下级所有业务员的活动奖励之和</p>

          <p className="title marTop10">推广费:</p>
          <p className="desc">统计时间段内已支付的获得-已撤单扣减-已退保扣减</p>
        </div>
    )
  };
  return (
    <Popover
      content={getContent()}
      trigger="hover"
      placement="bottom"
    >
      <QuestionCircleOutlined />
    </Popover>
  );
};

// 组件：昨日统计
const RegularPopYesterday = () => {
  const getContent = () => {
    return (
      <div className="activity_yesterday_question_tips">
        <p className="title">统计规则:</p>
        <p className="desc">按承保时间统计昨日 0 点-24 点，包含当前登录账户 所属机构及其下级机构团队</p>
      </div>
    )
  };
  return (
    <Popover
      content={getContent()}
      trigger="hover"
      placement="bottom"
    >
      <QuestionCircleOutlined />
    </Popover>
  );
};

// 组件：活动业绩
const ActivityStatistic = props => {
  const [state, setState] = useState({});
  useEffect(_ => {
    getData();
  }, []);
  // 获取统计数据
  const getData = () => {
    axios_({
      url: '/api/commission/activityRule/getCompanyCondition',
      method: 'get',
      headers: {
        'access-token': props.token
      }
    }).then(res => {
      if (res.data.status === 200) {
        setState(res.data.data || {});
      }
    }).catch(() => { });
  };
  return (
    <div className="activity_statistic_home_div">
      <div className="data_card right24">
        <div className="card_title">进行中活动</div>
        <p><span>{state.activityCount || '0'}</span> 个</p>
      </div>
      <div className="data_card right24">
        <div className="card_title">业务员奖励</div>
        <p><span>{numFormat2Thousand(state.agencyRewardFee)}</span> 元</p>
      </div>
      {
        isMechant() &&
        <div className="data_card">
          <div className="card_title">机构获得奖励</div>
          <p><span>{numFormat2Thousand(state.companyRewardFee)}</span> 元</p>
        </div>
      }
      {
        !isMechant() &&
        <div className="data_card">
          <div className="card_title">推广费总计</div>
          <p><span>{numFormat2Thousand(state.feeTotal)}</span> 元</p>
        </div>
      }
    </div>
  )
};

// 组件： 活动业绩和作业业绩（原数据统计）
export const ActivityAndYesterday = props => {
  const [activeKey, SetActiveKey] = useState("2");
  return (
    <div className="activity_yesterday_div">
      <Tabs
        onChange={activeKey => {
          Utils.customTrack('MerchantHomeClick', {
            element_content: activeKey === '1' ? '活动业绩' : '昨日数据'
          });
          SetActiveKey(activeKey)
        }}
        tabBarExtraContent={
          activeKey === "1" ?
            hasPermission(SYSTEMPermission.ACTIVE_MANAGEMENT) && !props.pageLoading && <a
              onClick={_ => {
                Utils.customTrack('MerchantHomeClick', { element_content: '活动管理' });
                props.history.push('/activity/activitylist')
              }}
              className="extra_div"
            >活动管理</a>
            :
            activeKey !== "3" && hasPermission(SYSTEMPermission.ONLINE_POLICY) && !props.pageLoading && <a onClick={_ => props.history.push('/policySys/onlinePolicy')} className="extra_div">线上保单</a>
        }>
        <TabPane
          tab={<div className="tabs_div">
            {/* <Icon type="bar-chart" /> */}
            <BarChartOutlined />
            <span>昨日数据</span>
            <RegularPopYesterday />
          </div>}
          key="2">
          <DataCount
            yesterdayPolicyCount={props.yesterdayPolicyCount}
            yesterdayPremiumSum={props.yesterdayPremiumSum}
            yesterdayPromotionFee={props.yesterdayPromotionFee}
            pageConfig={props.pageNamesConfig.DataCount}
          />
        </TabPane>
        <TabPane
          tab={<div className="tabs_div">
            {/* <Icon type="line-chart" /> */}
            <LineChartOutlined />
            <span>活动业绩</span>
            <RegularPop />
          </div>}
          key="1">
          <ActivityStatistic
            {...props}
          />
        </TabPane>
        {
            (Utils.getMobilePhone() ==='18807109886' || Utils.getMobilePhone() ==='18888866666' || Utils.getMobilePhone() ==='18899990000') && <TabPane
            tab={<div className="tabs_div">
             <AreaChartOutlined />
              <span>重点产品</span>
              {/* <RegularPop /> */}
            </div>}
            key="3">
              <KeyProducts  {...props}/>
          </TabPane>
        }


      </Tabs>

    </div>
  );
};
